import React from "react";
import { motion } from "framer-motion";
import ReportPageHeader from "./ReportPageHeader";
import {
    reportContainer,
    reportDetailContainer,
    reportDetailPage,
    reportPage,
    reportShell,
} from "./reportTheme";

const ReportPageLayout = ({
    title,
    breadcrumb,
    hubPath,
    subtitle,
    headerIcon,
    onRefresh,
    exportSheets,
    exportFileName,
    showExport = true,
    showPrint = true,
    compactTop = false,
    filterPanel,
    summaryPanel,
    children,
}) => (
    <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className={`${compactTop ? reportDetailPage : reportPage} fcl-report-page`}
    >
        <style>{`
            @media print {
                .fcl-report-page .print\\:hidden { display: none !important; }
                .fcl-report-page {
                    padding: 0 !important;
                    background: #fff !important;
                }
                .dark .fcl-report-page { background: #fff !important; }
                .fcl-report-print-content * {
                    color: #111 !important;
                }
                .fcl-report-print-content .dark\\:bg-slate-800,
                .fcl-report-print-content .dark\\:bg-slate-900 {
                    background: #fff !important;
                }
            }
        `}</style>
        <div className={compactTop ? reportDetailContainer : reportContainer}>
            <div className={`${reportShell} print:hidden`}>
                <ReportPageHeader
                    title={title}
                    breadcrumb={breadcrumb}
                    hubPath={hubPath}
                    subtitle={subtitle}
                    icon={headerIcon}
                    onRefresh={onRefresh}
                    exportSheets={exportSheets}
                    exportFileName={exportFileName || title}
                    showExport={showExport}
                    showPrint={showPrint}
                    embedded
                    compact={compactTop}
                />
            </div>

            <div className={`fcl-report-print-content ${compactTop ? "space-y-2" : "space-y-3"}`}>
                {filterPanel}
                {summaryPanel}
                {children}
            </div>
        </div>
    </motion.div>
);

export default ReportPageLayout;
